// src/utils/searchPreviewUtils.js

export const getHighlightedPreview = (text, query) => {
    if (!text) return '';
    const tokens = (query.match(/\w+/g) || []).map(token => token.toLowerCase());
    if (tokens.length === 0) {
        return text.length > 80 ? text.substring(0, 80) + ' ... ' : text;
    }
    const words = text.split(/\s+/);
    const snippets = [];
    for (let i = 0; i < words.length; i++) {
        const wordClean = words[i].replace(/[^\w]/g, '').toLowerCase();
        if (tokens.some(token => token === wordClean)) {
            const start = Math.max(0, i - 15);
            const end = Math.min(words.length, i + 16);
            let snippetWords = words.slice(start, end).map(w => {
                tokens.forEach(token => {
                    const regex = new RegExp(`\\b(${token})\\b`, 'gi');
                    w = w.replace(regex, '<b>$1</b>');
                });
                return w;
            });
            const snippetStr = snippetWords.join(' ');
            if (!snippets.includes(snippetStr)) {
                snippets.push(snippetStr);
            }
        }
    }
    let preview = snippets.length > 0
        ? snippets.join(' ... ')
        : (text.length > 80 ? text.substring(0, 150) + ' ... ' : text);

    if (preview.length > 400) {
        preview = preview.substring(0, 400) + ' ...';
    }
    return preview;
};

export const resultMatchesFilter = (result, filterString) => {
    if (!result.metadata || !result.metadata.keywords) return false;
    const filterChain = filterString.split(' > ').map(s => s.trim());
    const docKeywords = result.metadata.keywords;
    if (docKeywords.length < filterChain.length) return false;
    for (let i = 0; i < filterChain.length; i++) {
        if (docKeywords[i] !== filterChain[i]) return false;
    }
    return true;
};
